/**
 * Custom site-flyout functionality
 */
jQuery(function($){
    // transitionend timeout
    var endTimeout = 500;
    // discover flyouts and create/assoc triggers
    function discoverFlyouts() {
        $('.site-flyout').each(function(){
            var id = this.id;
            // anchor modals to body, when creating modals in VC, HTML tends to get deeply nested
            $(this).not('is-anchored').addClass('is-anchored').appendTo('body');
            // fixed missing # and adds trigger class
            $('a[href="#' + this.id + '"], a[href="' + this.id + '"]')
                .attr('href', '#' + this.id)
                .removeClass('flyout-trigger')
                .addClass('flyout-trigger');
        });
    }
    function openFlyout(selector) {
        var el = $(selector);
        if (!el.length) return;
        $('body').addClass('site-flyout-active');
        el.addClass('active in');
    }
    function closeFlyout(selector) {
        var el = $(selector);
        if (!el.length) return;
        el.removeClass('in');
        // wait until css transition is done
        setTimeout(function(){
            el.removeClass('active');
            $('body').removeClass('site-flyout-active');
        }, endTimeout);
    }
    $('body').on('click', '.flyout-trigger', function(e){
        e.preventDefault();
        openFlyout($(this).attr('href'));
    });
    $('.site-flyout__close, .site-flyout__backdrop').click(function(){
        closeFlyout($(this).closest('.site-flyout'));
    });
    discoverFlyouts();
    //openFlyout('#site-flyout--our-customers');
});
